import { render, staticRenderFns } from "./Approval.vue?vue&type=template&id=7bdabfa2&scoped=true&"
import script from "./Approval.vue?vue&type=script&setup=true&lang=js&"
export * from "./Approval.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Approval.vue?vue&type=style&index=0&id=7bdabfa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdabfa2",
  null
  
)

export default component.exports